// src/components/ui/SectionTitle.jsx
import React from "react";

export default function SectionTitle({ children }) {
  return (
    <h3 className="text-xl font-bold text-text-section mb-2">
      {children}
    </h3>
  );
}